/* eslint-disable camelcase -- FIXME: automatically added for existing issue */
import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getEmployerQleApprovalEmails = ({ groupId: group_id }) =>
  call(websocketFetch, 'get_employer_qle_approval_emails', { group_id });
